import { Injectable } from '@angular/core';

Injectable()
export class Globals{
    showNoInternet = false;
    showData = true;
    alert: any;
    bottomTabProfile = 'Profile';
    alertsArr = [];
    static isMobile:boolean = false;
    static isMoreRoutingMobileApp:boolean = false;
}